import { render, staticRenderFns } from "./CreateContractFromUserComponent.vue?vue&type=template&id=1af13a47&scoped=true"
import script from "./CreateContractFromUserComponent.vue?vue&type=script&lang=js"
export * from "./CreateContractFromUserComponent.vue?vue&type=script&lang=js"
import style0 from "./CreateContractFromUserComponent.vue?vue&type=style&index=0&id=1af13a47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af13a47",
  null
  
)

export default component.exports